import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import locale from 'element-plus/es/locale/lang/zh-cn';

import App from './App.vue'
import router from './router'

import 'element-plus/dist/index.css'
import './assets/css/main.css'

// 刷新页面路径重新跳转
let refresh = true;
import { resetRouter } from './router';
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    let title: any = to.meta.title;
    document.title = title;
  }
  if (localStorage.getItem('token') == undefined || localStorage.getItem('token') == 'undefined') {
    resetRouter('remove');
    next();
  } else {
    if (refresh) {
      resetRouter('add');
      setTimeout(() => {
        refresh = false;
        next({ path: to.redirectedFrom != undefined ? to.redirectedFrom.fullPath : to.fullPath, query: to.query });
      }, 200)
    } else {
      next();
    }
  }
})

const app = createApp(App)

app.use(createPinia())
app.use(ElementPlus, { locale })
app.use(router)

app.mount('#app')
